import { defineAction } from '~/prix'
import communityFetchAction from './communityFetch.action.json' with { type: 'json' }
import { communityObject } from '../communityObject'
import { z } from 'zod'

const communityFetchDefinition = defineAction({
  ...communityFetchAction,

  input: z.object({ id: z.string() }),
  output: communityObject,
})

export default communityFetchDefinition
